<template>
    <div class="extensionAgentCom">
        <div class="searchBox">
            <el-button class="batchEdit" @click.native="batchEditGrade" :disabled="selectArr.length === 0">批量修改等级</el-button>
            <el-select v-model="params.leveltype" placeholder="请选择">
                <el-option v-for="item in extensionAgent" :key="item.name" :label="item.name" :value="item.code"></el-option>
            </el-select>
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" class="joinTime" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="pickerOptions" v-model="time" type="datetimerange"></el-date-picker>
            <el-input class="keyword" v-model.trim="params.keyword" placeholder="推广员昵称/上级推广员/手机号"></el-input>
            <el-button @click.native="search">搜索</el-button>
        </div>
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" min-width="55"></el-table-column>
            <el-table-column label="头像/昵称" min-width="172" width="172">
                <template slot-scope="scope">
                    <div class="imgName">
                        <div class="imgBox">
                            <img :src="scope.row.headimageurl" alt="">
                        </div>
                        <span>{{scope.row.name}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="leveltypetext" min-width="172" width="172px" label="推广员级别" class-name="center"></el-table-column>
            <el-table-column prop="mobileno" min-width="172" width="172px" label="手机号码" class-name="center">
                <template slot-scope="scope">
                    <div>
                        <span v-if="scope.row.mobileno">{{scope.row.mobileno}}</span>
                        <span v-else>-</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="parentname" label="上级推广员" class-name="center"></el-table-column>
            <el-table-column prop="totalclientcount" label="累计客户（人）" class-name="center"></el-table-column>
            <el-table-column prop="totalclientinvite" label="累计邀请（人）" class-name="center"></el-table-column>
            <el-table-column prop="totalbrokerage" label="累计收益（元）" class-name="center"></el-table-column>
            <el-table-column prop="datetime" label="加入时间" min-width="102px" width="102px" class-name="center"></el-table-column>
            <el-table-column label="操作" width="295px" min-width="295px" class-name="right">
                <template slot-scope="scope">
                    <div class="action">
                        <span class="actionItem" @click="generalizeAgentMsg(scope.row)">详情</span>
                        <span class="line">|</span>
                        <span class="actionItem" @click="promoteLink()">推广链接</span>
                        <span class="line">|</span>
                        <span class="actionItem" @click="editGrade(scope.row)">修改等级</span>
                        <span class="line">|</span>
                        <span class="actionItem" @click="checkAndReturn(scope.row)">清退</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Page :total="total" ref="page"></Page>
        <ReturnExtensionAgent ref="returnExtensionAgent" @getList="getExtensionAgentList"></ReturnExtensionAgent>
        <EditExtensionAgentGrade ref="editExtensionAgentGrade" @getList="getExtensionAgentList"></EditExtensionAgentGrade>
        <ChoiceShop ref="choiceShop"></ChoiceShop>
    </div>
</template>
<script>
import Page from '@/base/page/page'
import ReturnExtensionAgent from './returnExtensionAgent'
import EditExtensionAgentGrade from './editExtensionAgentGrade'
import ChoiceShop from './addShop'
import {promiseUrlToQRCode} from 'common/js/tools'
import {extensionAgentList, auditPassRejectReturn} from '@/api/extensionAgent'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'extensionAgentCom',
    data() {
        return {
            total: 500,
            params: {
                leveltype: '',
                beginTime: '',
                keyword: '',
                endTime: ''
            },
            time: '',
            extensionAgent: [
                {code: '', name: '全部等级'},
                {code: '1', name: '普通推广员'},
                {code: '2', name: '高级推广员'},
                {code: '3', name: '超级推广员'}
            ],
            tableData: [],
            selectArr: [],
            page: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            }
        }
    },
    mounted() {
        this.page = this.$refs.page.page
        this.getExtensionAgentList()
    },
    methods: {
        handleSelectionChange(v) {
            this.selectArr = JSON.parse(JSON.stringify(v))
        },
        // 清退
        checkAndReturn(row) {
            this.$refs.returnExtensionAgent.dialogVisible = true
            this.$refs.returnExtensionAgent.params.innerid = row.innerid
        },
        // 修改等级
        editGrade(row) {
            this.$refs.editExtensionAgentGrade.openDialog(row)
        },
        // 批量修改等级
        batchEditGrade() {
            let len = this.selectArr.length
            let highGrade = 0, commonGrade = 0, superGrade = 0
            let innerid = ''
            this.tableData.forEach(obj1 => {
                this.selectArr.forEach(obj2 => {
                    if (obj1.leveltype === obj2.leveltype && obj1.innerid === obj2.innerid) {
                        if (obj2.leveltype === 1) {
                            commonGrade++
                        } else if (obj2.leveltype === 2) {
                            highGrade++
                        } else if (obj2.leveltype === 3) {
                            superGrade++
                        }
                    }
                    innerid = innerid + ',' + obj2.innerid
                })
            })
            this.$refs.editExtensionAgentGrade.batchEdit(len, highGrade, commonGrade, superGrade, innerid)
        },
        // 推广链接
        promoteLink() {
            this.$refs.choiceShop.openDialog()
        },
        // 详情
        generalizeAgentMsg(row) {
            this.$router.push({path: '/marketingCenter/commodityDistribution/generalizeAgentClientMsg', query: {innerid: row.innerid}})
        },
        // 获取列表
        getExtensionAgentList() {
            this.setLoading(false)
            extensionAgentList({
                data: Object.assign({}, this.params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data
                    this.total = data.pageableData.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 搜索
        search() {
            this.getExtensionAgentList()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'time': {
            handler(newV, oldV) {
                if (!newV) {
                    this.params.beginTime = ''
                    this.params.endTime = ''
                } else {
                    this.params.beginTime = newV[0]
                    this.params.endTime = newV[1]
                }
            }
        },
        deep: true
    },
    components: {
        Page, ReturnExtensionAgent, EditExtensionAgentGrade, ChoiceShop
    }
}
</script>
<style lang="scss">
@import "~common/scss/mixin";
    .extensionAgentCom{
        .searchBox{
            margin-top: 15px;
            .batchEdit{
                width: 150px;
                margin-right: 30px;
            }
            .el-select{
                width: 152px;
                margin-right: 30px;
                .el-select__caret{
                    line-height: 32px;
                }
            }
            .keyword{
                width: 330px;
                margin-right: 30px;
            }
            .joinTime{
                width: 224px;
                margin-right: 30px;
                .el-input__prefix{
                    .el-input__icon{
                        line-height: 32px;
                    }
                }
                 .el-input__icon{
                    line-height: 24px;
                }
                .el-range-separator{
                    line-height: 22px;
                }
            }
        }
        .el-table{
            margin-top: 20px;
            .action{
                span{
                    color: #409EFF;
                }
                .line{
                    margin: 5px;
                }
                .actionItem{
                    cursor: pointer;
                }
            }
            .imgName{
                display: flex;
                align-items: center;
                .imgBox{
                    width: 50px;
                    height: 50px;
                    margin-right: 10px;
                    img{
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                    }
                }
            }
            .center{
                .cell{
                    text-align: center;
                }
            }
            .right{
                .cell{
                    text-align: right;
                }
            }
        }
    }
</style>